import { Layout } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../store/hooks';
import { selectActiveRequestId } from '../../store/requests-slice';
import RequestPreviewSiderHeader from '../request-preview-sider-header/request-preview-sider-header';
import RequestPreview from '../request-preview/request-preview';
import styles from './request-preview-sider.module.css';

interface Props {
  collapsed: boolean;
  onClose: () => void;
  fullscreenUrl: string;
}

const RequestPreviewSider = ({ collapsed, onClose, fullscreenUrl }: Props): JSX.Element => {
  const { t } = useTranslation('common');
  const activeRequestId = useAppSelector(selectActiveRequestId);

  const handleEscPress = (event: KeyboardEvent) => {
    if (event.key === 'Escape' || event.keyCode === 27) {
      onClose();
    }
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => handleEscPress(event);

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { Sider } = Layout;

  return (
    <Sider collapsedWidth={0} width={765} trigger={null} collapsed={collapsed}>
      {!collapsed && (
        <div className={styles.siderContent}>
          <RequestPreviewSiderHeader
            submenuTitle={t('signScanRequest.label.request')}
            closePreview={onClose}
            fullscreenUrl={fullscreenUrl}
          />
          <div className={styles.previewContent}>
            {activeRequestId && <RequestPreview signRequestId={activeRequestId} />}
          </div>
        </div>
      )}
    </Sider>
  );
};

export default RequestPreviewSider;
